import axios from "axios";

export async function upload(data: any[]): Promise<string[]> {
  const respose = await axios.post("/upload", { data });
  return respose.data;
}
